import React from "react";
import slider1 from "../images/sliders/slider1.jpg";

const faqs = [
  {
    question: "Top Rayon Fabric Materials are made of ?",
    answer:
      "We have recently launched the ability to shop fabrics online and shop poles & tracks online from our website too.",
  },
  {
    question: "The Global Fabrics Distributor must be professional !!",
    answer:
      "Choose from many fabrics and design your. Create and print only the fabric you need aqueous solution for fiber surface .",
  },
  {
    question: "The curse of Fabric Products & Accessories !!",
    answer:
      "We have built a strong alliance with some of industry tech giants to build a most efficient data analysis and processing.",
  },
  {
    question: "What types of elastic tapes and webbing do you manufacture?",
    answer:
      "We produce woven, knitted, jacquard, and buttonhole elastic tapes in custom widths, tensions, colors, and stretch ratios for garments and medical apparel.",
  },
  {
    question: "Do you supply custom garment badges, stickers, and ribbons?",
    answer:
      "Yes, we offer custom-branded woven ribbons, printed garment badges, heat-transfer stickers, and barcode accessories tailored to global buyer specifications.",
  },
  {
    question: "What export quality standards and certifications do you comply with?",
    answer:
      "Our manufacturing adheres to strict international compliance, OEKO-TEX safety benchmarks, and verified quality control for European, US, and Canadian export markets.",
  },
];

const PopularQuestions = () => {
  return (
    <section className="py-20 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14" data-aos="fade-up">
          <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
            Frequently Asked
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
            POPULAR QUESTIONS
          </h2>
          <p className="text-slate-500 mt-3 text-sm sm:text-base leading-relaxed">
            If you work in the garments industry, chances are you work with
            textiles almost constantly. Whether you’re shopping for, printing on,
            or working with textiles, they never seem to differ much from any
            elastic you’ve worked with.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="flex justify-center" data-aos="fade-right">
            <img
              src={slider1}
              alt="Factory machinery and accessories manufacturing"
              className="w-full max-w-md rounded-2xl shadow-lg border border-slate-200/80 object-cover"
            />
          </div>

          <div className="space-y-4" data-aos="fade-left">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                tabIndex={0}
                className="collapse collapse-plus border border-slate-200 bg-white rounded-2xl shadow-sm hover:border-slate-300 transition-colors"
              >
                <div className="collapse-title font-bold text-slate-800 text-base py-5 px-6">
                  {faq.question}
                </div>
                <div className="collapse-content px-6 text-slate-600 text-sm leading-relaxed">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularQuestions;

